import { Controller } from "stimulus";
import Rails from '@rails/ujs';

export default class extends Controller {
  static targets = ["apikey"]

  connect() {
  }

  toggleVisibility(event) {
    event.preventDefault();
    this.apikeyTarget.classList.toggle('blurred');
    this.apikeyTarget.classList.toggle('revealed');

    // Change button text
    event.currentTarget.textContent = this.apikeyTarget.classList.contains('blurred') ? 'Click to reveal' : 'Hide API key';
  }
}
